import React, { useMemo } from "react";
import { parseISO } from "date-fns";
import { Typography, Box } from "@mui/material";
import StyledTooltip from "../../../StyledTooltip/StyledTooltip";
import { formatEmpty } from "../../../../utils/formatHelpers";
import { nullCheck } from "../../../../utils/dataHelpers";
import { formatDate } from "../../../../utils/dateHelpers";
import useEtaStatus from "../../../../hooks/useEtaStatus/useEtaStatus";

export default function DateTimeRangeCell(cell) {
  const type = nullCheck(cell, null, "column", "id");
  const dateOnly = nullCheck(cell, false, "column", "dateOnly");
  const timeOnly = nullCheck(cell, false, "column", "timeOnly");
  const stopTypeLabel = nullCheck(cell, "", "column", "stopType");
  const lateDateType = nullCheck(cell, null, "column", "lateDate");
  const active = nullCheck(cell, false, "row", "original", "activeRow");

  const schedEarlyDate = cell.value;
  const schedLateDate = nullCheck(cell, null, "row", "original", lateDateType);
  const parsedEarly = parseISO(schedEarlyDate);
  const parsedLate = parseISO(schedLateDate || schedEarlyDate);

  const brokerageStatus = nullCheck(cell, "", "row", "original", "brokerageStatus");
  const etaStatus = nullCheck(cell, null, "row", "original", "etaStatus");
  const { currentStatus } = useEtaStatus(etaStatus);

  const dateFormat = dateOnly ? "MM/dd/yyyy" : timeOnly ? "HH:mm" : "MM/dd/yyyy HH:mm";
  const multiDateAlert = schedLateDate && schedLateDate !== schedEarlyDate ? "*" : "";

  const textColor = useMemo(() => {
    const statusColor = currentStatus?.backgroundColor || "black_solid.80";
    const isOrigin = stopTypeLabel === "Origin" && ["AVA", "COV", "COVCOM", "DIS"].includes(brokerageStatus);
    const isDestination = stopTypeLabel === "Destination" && ["LOA", "LOAD", "DEL"].includes(brokerageStatus);
    const isSpecialType = ["newEta", "lastCallDateTime"].includes(type);

    if (active) return "white_opacity.100";
    if (isOrigin || isDestination || isSpecialType) return statusColor;
    return "black_solid.80";
  }, [active, stopTypeLabel, type, currentStatus]);

  return (
    <StyledTooltip
      titleObject={stopTypeLabel ?
        <Box>
          <Box sx={{ marginBottom: "5px" }}>
            <Typography variant="body1">
              {`${stopTypeLabel} Early`}
            </Typography>
            <Typography variant="body1">
              {formatDate(parsedEarly, dateFormat, null)}
            </Typography>
          </Box>
          <Box>
            <Typography variant="body1">
              {`${stopTypeLabel} Late`}
            </Typography>
            <Typography variant="body1">
              {formatDate(parsedLate, dateFormat, null)}
            </Typography>
          </Box>
        </Box> : null
      }
    >
      <Typography variant="body1" color={textColor}>
        {formatEmpty(formatDate(parsedEarly, dateFormat, null))}{multiDateAlert}
      </Typography>
    </StyledTooltip>
  );
}